import { render, staticRenderFns } from "./AddDomainPriceModal.vue?vue&type=template&id=44a0a1ae&"
import script from "./AddDomainPriceModal.vue?vue&type=script&lang=js&"
export * from "./AddDomainPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDomainPriceModal.vue?vue&type=style&index=0&id=44a0a1ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports